import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Footer from './components/footer';


ReactDOM.render(
  <React.StrictMode>
    <App />

  </React.StrictMode>,
  document.getElementById('root')
);

// --- FIX: Service Worker Unregistration ---
// This code is a failsafe to unregister any Service Worker that might have been
// installed by a previous build. This will prevent the Service Worker from serving
// stale, cached versions of index.html.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
    console.log("Stale Service Worker successfully unregistered. Deployment cache issue resolved.");
  }).catch(error => {
    console.error('Service Worker unregistration failed:', error.message);
  });
}
// ----------------------------------------


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals 
//http://localhost:3000/textbook/module?id=619bec796daaa10f5658558e
reportWebVitals();